import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IReminder } from '../model/reminder.model';
import { BehaviorSubject, Observable } from 'rxjs';


export interface ReminderModalState {
  reminder: IReminder;
  soundOn: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReminderCenterService {
  private readonly _state$ = new BehaviorSubject<ReminderModalState | null>(null);
  private dialogRef?: MatDialogRef<unknown>;
  private openingDialog = false;
  readonly state$: Observable<ReminderModalState | null> = this._state$.asObservable();

  constructor(private readonly dialog: MatDialog) {}

  get currentState(): ReminderModalState | null {
    return this._state$.value;
  }

  show(reminder: IReminder) {
    this._state$.next({ reminder, soundOn: true });
    void this.ensureDialogOpen();
  }

  close() {
    this._state$.next(null);
    this.dialogRef?.close();
    this.dialogRef = undefined;
  }

  stopSound() {
    const cur = this._state$.value;
    if (!cur) return;
    this._state$.next({ ...cur, soundOn: false });
  }

  private async ensureDialogOpen() {
    if (this.dialogRef || this.openingDialog || !this._state$.value) {
      return;
    }

    this.openingDialog = true;

    try {
      const { ReminderPopupComponent } = await import(
        'projects/mind-your-tax/myt/utils/standalone-components/reminder-popup/reminder-popup.component'
      );

      if (!this._state$.value || this.dialogRef) {
        return;
      }

      this.dialogRef = this.dialog.open(ReminderPopupComponent, {
        disableClose: true,
        autoFocus: false,
        restoreFocus: false,
        panelClass: 'reminder-popup-dialog-panel',
        width: 'min(720px, calc(100vw - 24px))',
        maxWidth: 'calc(100vw - 24px)',
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = undefined;
        if (this._state$.value) {
          this._state$.next(null);
        }
      });
    } finally {
      this.openingDialog = false;
    }
  }
}
